export default {
  modal: {
    close: "Close",
    delinquentModal: {
      heading:
        "Action Required: Approve Your Subscription Charge to Restore Full Service",
      paragraph1:
        "Your pending subscription charge requires approval. While we continue to collect marketing consent for your contacts, syncing to Klaviyo is currently paused.",
      paragraph2:
        "Please approve your pending charges to update your Klaviyo with the missing consent data, regain access to your Control Panel, and keep your data syncing smoothly.",
      cta: "Approve Charge Now",
    },
  },

  imagePreviewCarousel: {
    titles: {
      soft_opt_in: "Soft opt-in consent",
      soft_opt_out: "Explicit opt-in consent",
      implied_consent: "Implied consent / No consent required",
    },
  },

  cta: {
    needHelp: "Need help?",
  },
  copyContent: {
    copy: "Copy to Clipboard",
    copied: "Copied!",
  },
  emptyState: {
    dashboard: {
      feature: "Come back later",
      heading: "No Data to Display",
      description: "Your data will appear as we verify your contacts.",
      cta: "Refresh",
    },
  },
  table: {
    searchPlaceholder: "Search...",
    empty: "No rows found",
    error: {
      heading: "Oops, something went wrong",
      description:
        "We have been notified, if this issue persists, please contact <1>support</1>",
    },
    pageInfo: "Page <1>{{pageIndex}}</1>",
    totalInfo: "Showing {{pageSize}} results",
  },
  alertBanner: {
    billing: {
      approvalRequired:
        "<strong>Action required:</strong> You have a pending billing charge requiring approval",
      chargeDeclined:
        "<strong>Action required:</strong> Upgrade to the next plan in order to continue using Dataships",
      linkCta: "Go to Billing",
      dismiss: "Dismiss",
    },
  },
  superAdminBanner: {
    title: "Warning: You are logged in as {{customerName}}",
    cta: "Log out of Customer",
  },
  imageUpload: {
    removeLink: "Remove",
  },
  fileInput: {
    placeholder: "Click here to choose a file",
    cta: "Upload",
  },
  accountSwitcher: {
    addCompany: "Add a new Company",
    loading: "Creating Company...",
  },
  matIntegrationCard: {
    install: "Install",
    configure: "Configure",
    blurb:
      "<0>Connect your {{ name }} account to Dataships to sync your subscribers and supercharge your marketing efforts.",
    confirm: "Confirm",
    cancel: "Cancel",
    uninstallHeading: "Uninstall {{name}} Integration",
    confirmation:
      'Are you sure? Clicking "Confirm" will result in your {{name}} integration being uninstalled. This will stop Dataships from syncing any contacts to {{name}} unless you re-install the integration.',
    success: "Successfully uninstalled {{name}} integration",
    error: "Failed to uninstall {{name}} integration",
    uninstall: "Uninstall",
  },
  onboardingProgession: {
    label:
      "{{step}}/6. By clicking next you will be brought to the next step of onboarding",
  },
  matCard: {
    errors:
      "Something went wrong trying to save your configuration. Please see the details below and try again.",
  },
} as const;
